var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alert-compact',{attrs:{"variant":"warning","title":"Não deixe suas hospedagens ficarem suspensas!","btn-text":"Ativar","btn-link":"/payment/auto-recharge","icon-class":"fas fa-window-close","show-ignore":"","on-ignore":_vm.hideAutoRechargeAlert}},[_vm._v(" Ative a opção de recarga automática e mantenha seus serviços sempre ativos. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }